<mat-form-field appearance="outline" class="lc-rich-text" floatLabel="always" [class.mat-form-field-readonly]="readonly" [class.ng-valid]="errors === ''" [id]="idPrefix + '-form-field'">
  <mat-label>{{label}}</mat-label>
  <lc-editor-control [disabled]="readonly" [errorState]="hasErrors" [(formControl)]="formControl" (change)="onTextChange($event)" />
  <mat-hint>{{hint}}</mat-hint>
  @if (formControl && formControl.invalid) {
    <mat-error [innerHTML]="errors" />
  }
</mat-form-field>
